import { Accordion } from "react-bootstrap";
import { SmallPlatformIcon } from "../platformsIcon";
import { PLATFORM_LIST } from "../../../../config/constants";
import { useEffect, useState } from "react";
import {
  removeActivePlatformTemp,
  toggleActivePlatformTemp,
  updatePlatformSelectionFilter,
} from "../../../../redux/slices/lomavisCreator/lomavisCreator";
import { useDispatch, useSelector } from "react-redux";
import { useTranslate } from "@tolgee/react";
import IsLoadingIndicator from "../../../isLoadingIndicator";

const SelectByPlatform: React.FC = () => {
  const { t } = useTranslate();
  const dispatch = useDispatch();
  const { locations } = useSelector((state: any) => state.locationsList);
  const {
    selectionFilters: { byPlatform },
    tempState: { creator_multipost_config: creatorMultipostConfig },
  } = useSelector((state: any) => state.lomavisCreator);
  const selectLocationsByPlatform = (platform: string) => {
    dispatch(updatePlatformSelectionFilter({ platform }) as any);
    const platformIsSelected = byPlatform.includes(platform);
    locations.map((location: any) => {
      if (location?.[`is_${platform}_linked`]) {
        if (platformIsSelected) {
          dispatch(
            removeActivePlatformTemp({
              platform,
              locationUUid: location.uuid,
            })
          );
          return;
        }
        dispatch(
          toggleActivePlatformTemp({
            locationUUid: location.uuid,
            platform,
          })
        ) as any;
      }
    });
  };
  const [activePlatforms, setActivePlatforms] = useState<string[]>(null);
  useEffect(() => {
    const activePlatforms = locations
      .map((location) => {
        return PLATFORM_LIST.filter((platform) => {
          return location?.[`is_${platform}_linked`];
        });
      })
      .flat()
      .filter((value, index, self) => self.indexOf(value) === index);
    setActivePlatforms(activePlatforms);
  }, [locations]);
  return (
    <div className="card p-3 bg-white py-5">
      <Accordion defaultActiveKey="0">
        <Accordion.Item eventKey="0">
          <Accordion.Header>
            {t("lomavisCreator.select_by_platform")}
          </Accordion.Header>
          <Accordion.Body>
            <div className="d-flex flex-wrap w-100">
              {activePlatforms == null && <IsLoadingIndicator />}
              {activePlatforms?.map((platform) => {
                return (
                  <div className="m-1">
                    <SmallPlatformIcon
                      key={platform}
                      platform={platform}
                      active={byPlatform.includes(platform)}
                      onClick={() => selectLocationsByPlatform(platform)}
                    />
                  </div>
                );
              })}
            </div>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </div>
  );
};

export default SelectByPlatform;
